import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalProgressCard = ({ 
  title, 
  current, 
  target, 
  unit = '',
  icon = 'Target',
  deadline,
  status = 'in-progress'
}) => {
  const progress = Math.min((current / target) * 100, 100);
  
  const getStatusConfig = () => {
    if (status === 'completed') {
      return {
        color: 'var(--color-success)',
        bgColor: 'bg-success/10',
        textColor: 'text-success',
        label: 'Completed'
      };
    }
    if (status === 'at-risk') {
      return {
        color: 'var(--color-warning)',
        bgColor: 'bg-warning/10',
        textColor: 'text-warning',
        label: 'At Risk'
      };
    }
    return {
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10',
      textColor: 'text-accent',
      label: 'In Progress'
    };
  };

  const statusConfig = getStatusConfig();

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-md hover-lift transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${statusConfig?.bgColor}`}>
            <Icon name={icon} size={20} color={statusConfig?.color} strokeWidth={2.5} />
          </div>
          <div>
            <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
              {title}
            </h4>
            {deadline && (
              <p className="text-xs md:text-sm caption text-muted-foreground mt-1">
                Due: {deadline}
              </p>
            )}
          </div>
        </div>
        <span className={`text-xs md:text-sm font-semibold caption px-2 py-1 rounded ${statusConfig?.bgColor} ${statusConfig?.textColor}`}>
          {statusConfig?.label}
        </span>
      </div>
      <div className="space-y-3">
        <div className="flex items-baseline justify-between">
          <span className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
            {current}{unit}
          </span>
          <span className="text-sm md:text-base text-muted-foreground">
            of {target}{unit}
          </span>
        </div>

        <div className="relative h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full rounded-full transition-smooth"
            style={{ 
              width: `${progress}%`,
              backgroundColor: statusConfig?.color
            }}
          />
        </div>

        <div className="flex items-center justify-between text-xs md:text-sm">
          <span className={`font-semibold data-text ${statusConfig?.textColor}`}>
            {Math.round(progress)}% Complete
          </span>
          <span className="text-muted-foreground">
            {target - current}{unit} remaining
          </span>
        </div>
      </div>
    </div>
  );
};

export default GoalProgressCard;